import { createAsyncReducer } from '../../standard-actions/reducers';
import {
    ILoadDynamicFormAction,
    ILoadDynamicFormSuccessAction,
    ILoadDynamicFormErrorAction
} from '../actions/dynamic-form';
import { ITicketsState } from '../state';
import { initialState } from './initial-state';

export type DynamicFormAction
    = ILoadDynamicFormAction
    | ILoadDynamicFormSuccessAction
    | ILoadDynamicFormErrorAction;

const init = (state: ITicketsState, action: DynamicFormAction) => ({
    ...state,
    dynamicFormRequest: {
        ...initialState.dynamicFormRequest,
        status: action.status,
    }
});

const success = (state: ITicketsState, action: DynamicFormAction) => ({
    ...state,
    dynamicFormRequest: {
        ...initialState.dynamicFormRequest,
        status: action.status,
        formConfig: (action as ILoadDynamicFormSuccessAction).formConfig
    }
});

const failure = (state: ITicketsState, action: DynamicFormAction) => ({
    ...state,
    dynamicFormRequest: {
        ...initialState.dynamicFormRequest,
        status: action.status,
        error: (action as ILoadDynamicFormErrorAction).error
    }
});

export const dynamicFormReducer = createAsyncReducer(initialState, init, success, failure);
